import { cx } from "../lib/cx"

type StatusPillProps = {
  tone?: "success" | "warning" | "danger" | "neutral"
  label: string
  className?: string
}

const toneStyles: Record<NonNullable<StatusPillProps["tone"]>, string> = {
  success: "bg-emerald-100 text-emerald-700",
  warning: "bg-amber-100 text-amber-700",
  danger: "bg-rose-100 text-rose-700",
  neutral: "bg-slate-100 text-slate-600",
}

const StatusPill = ({ tone = "neutral", label, className }: StatusPillProps) => (
  <span
    className={cx(
      "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold",
      toneStyles[tone],
      className,
    )}
  >
    {label}
  </span>
)

export default StatusPill
